import React, { useEffect, useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import ReactLoading from "react-loading";
import { useNavigate } from "react-router-dom";

export const ContactBar = () => {
  const nav = useNavigate();
  const [imgloading, setImgloading] = useState(false);
  const [imgSrc, setImgSrc] = useState();
  const { t } = useTranslation();
  useEffect(() => {
    const imgDom = new Image();
    setImgloading(true);
    imgDom.src =
      "//files.authing.co/authing-website/wechat-enterprice-code.png";
    imgDom.onload = function () {
      setImgloading(false);
      setImgSrc(imgDom.src);
    };
  }, []);
  const LodingRender = () => {
    return (
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "center",
          alignContent: "center",
          paddingTop: "34px",
        }}
      >
        <ReactLoading
          type="spinningBubbles"
          color="#396aff"
          height={40}
          width={40}
        />
      </div>
    );
  };
  const contactMobileBarRender = () => {
    return (
      <div className="contact-bar-mobile">
        <div className="contact-bar-warp">
          <div
            className="online-button button"
            onClick={() => {
              _MEIQIA("assign", {
                agentToken: "06da7d49fcc1d84cc76efa1a2f8db954",
              });
              _MEIQIA("showPanel");
            }}
          >
            <>
              <i className="icon authing-icon authing-customer-service-2-linebeifen"></i>
              <span> {t("common.chat-online")}</span>
            </>
          </div>
          <a className="phone-button button" href="tel:400 888 2106">
            <i className="icon authing-icon authing-phone-linebeifen"></i>
            <span>{t("common.chat-phone")}</span>
          </a>
        </div>
      </div>
    );
  };
  const contactBarRender = () => {
    return (
      <div className="contact-bar">
        <div className="contact-bar-warp">
          <div
            className="chat-online bar-item"
            data-log="sidebar/online"
            onClick={() => {
              _MEIQIA("assign", {
                agentToken: "06da7d49fcc1d84cc76efa1a2f8db954",
              });
              _MEIQIA("showPanel");
            }}
          >
            <div className="contact-icon ">
              <i className="icon website-icon website-zaixianzixun"></i>
            </div>
            <div className="bar-item-label">{t("common.chatrobot.online")}</div>
            <div className="tip chat-online-tip">
              <div className="title">{t("common.chatrobot.onlineTip1")}</div>
              <div className="subtitle">{t("common.chatrobot.onlineTip2")}</div>
            </div>
          </div>

          <div className="wechat bar-item">
            <div className="contact-icon">
              <i className="icon website-icon website-qiweizixun"></i>
            </div>
            <div className="bar-item-label">{t("common.chatrobot.wecom")}</div>
            <div className="wechat-robot-content">
              <div className="wechat-robot-reqcode">
                {imgloading ? (
                  LodingRender()
                ) : (
                  <img src={imgSrc} alt="authing" />
                )}
              </div>
              <div className="text">{t("common.chatrobot.wecomTip")}</div>
              {/* <div className="text"></div> */}
            </div>
          </div>
          <div
            className="quotation-consultation bar-item"
            data-log="sidebar/quotation"
          >
            <div className="contact-icon">
              <i className="icon website-icon website-a-CEOyouxiang"></i>
            </div>
            <div className="bar-item-label">
              {t("common.chatrobot.ceoEmail")}
            </div>
            <div className="tip quotation-consultation-tip">
              <div className="title">ceo@authing.cn</div>
              <div className="subtitle">
                {t("common.chatrobot.ceoEmailTip")}
              </div>
            </div>
          </div>
          <div className="phone bar-item">
            <a href="tel:400-888-2106">
              <div className="contact-icon">
                <i className="icon website-icon website-dianhuazixun"></i>
              </div>
              <div className="bar-item-label">
                {t("common.chatrobot.phone")}
              </div>
              <div className="tip phone-box">
                <div className="title">400-888-2106</div>
                <div className="subtitle">{t("common.chatrobot.phoneTip")}</div>
              </div>
            </a>
          </div>
        </div>
        <div
          className="free-use-button"
          onClick={() => {
            nav("/authingform");
          }}
        >
          <i className="icon website-icon website-mianfeishiyong free-use-icon"></i>
          <div className="free-use-text">{t("common.chatrobot.freeUse")}</div>
        </div>
      </div>
    );
  };
  return (
    <>
      {contactBarRender()}
      {contactMobileBarRender()}
    </>
  );
};
